module.exports = __webpack_public_path__ + "static/img/1578_phase_function_Paper_Points.f84d8dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1578_phase_function_Paper_Points.png
// module id = ImUU
// module chunks = 0